import { Navigate } from 'react-router-dom';
import { PACKS_COLLECTION_LIVE } from '@/config/features';

export default function CardsPage() {
  // Card-economy surface — not live yet. See PACKS_COLLECTION_LIVE.
  // (Was already a dead-end stub; redirect beats stranding deep links.)
  if (!PACKS_COLLECTION_LIVE) return <Navigate to="/" replace />;
  return <Navigate to="/events" replace />;
}
